import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { searchActions, searchStatus, propertySkSearchBy } from '../../../store/searchStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { Circles } from "../../common/loadingComponent";
import BbCheckbox from "../../styling/bbCheckbox";
import Message from '../../common/message';
import ResponsiveTable from "../../layoutItems/responsiveTable";

import './propertySk.scss';

class PropertySkCadastreUnit extends React.Component {
    state = {
        expanded: false
    };

    static propTypes = {
        data: PropTypes.object.isRequired,
        hash: PropTypes.string,
        entityId: PropTypes.number
    };

    componentDidMount() {
        if (this.props.expanded) {
            this.expandClicked(this.props.data.cadastreUnitId)
        }
    }

    render() {
        const data = this.props.data;
        const includedInExportIds = Object.assign([], this.props.search.exportSettings.ids).includes(data.cadastreUnitId);

        return (
            <>
                <tr className="detail-row" onClick={() => this.expandClicked(data.cadastreUnitId)}>
                    <td>{data.region}</td>
                    <td>{data.district}</td>
                    <td>{data.municipality}</td>
                    <td>{data.cadastreUnitName}</td>
                    <td style={{ textAlign: "right" }}>
                        <span className="link-internal">
                            <Translate id='Report.Detail' />
                        </span>
                    </td>
                    <td className="hide-on-mobile" style={{ whiteSpace: "nowrap" }}>
                        <div className="bb-chk-pdf-export m-0" onClick={(e) => e.stopPropagation()}>
                            <BbCheckbox name="pdf-id" label={this.props.translate("Common.AddToReport")} id="pdf-id"
                                value={(this.props.search.exportSettings.all && !includedInExportIds) || (!this.props.search.exportSettings.all && includedInExportIds)}                                
                                onChange={(v) => v
                                    ? this.props.addToPdfExport(data.cadastreUnitId)
                                    : this.props.removeFromPdfExport(data.cadastreUnitId)
                                }
                            />
                        </div>
                    </td>
                </tr>
                <tr className="without-hover" style={{ display: this.state.expanded ? "" : "none", backgroundColor: "inherit" }}>
                    <td style={{ display: "none" }}></td>
                    <td colSpan={6} style={{ padding: "0 0 0 2em" }}>
                        <ResponsiveTable>
                            <table className="table table-report-section table-stretched">
                                <tbody>
                                    <tr className="hide-on-mobile" style={{ borderTopWidth: 0 }}>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.OwnershipDeedNo" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.RecordType" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.Area" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.ItemType" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.Location" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.LandId" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.OwnershipShare" /></td>
                                        <td className="bold"><Translate id="PropertySk.CadastreUnit.Burden" /></td>
                                    </tr>
                                    {this.renderContent(data.cadastreUnitId)}
                                </tbody>
                            </table>
                        </ResponsiveTable>
                    </td>
                </tr>
            </>
        );
    }

    renderContent = (cuId) => {
        const data = isNullOrUndefined(this.props.search.propertySk.cadastreUnitData) ? null : this.props.search.propertySk.cadastreUnitData[cuId];
        if (isNullOrUndefined(data))
            return null;

        if (data.status === searchStatus.requested || data.status === searchStatus.error) {
            return (
                <tr>
                    <td colSpan={8}>
                        {data.status === searchStatus.requested
                            ?
                            <Circles />
                            :
                            <Message type="error" message="" style={{ width: "100%" }}><Translate id="PropertySk.Error" /></Message>
                        }
                    </td>
                </tr>
            );
        }

        return (
            <>
                {data.data.map((d, index) =>
                    <tr key={index} style={{ display: this.state.expanded ? "" : "none", borderBottomWidth: index === data.data.length - 1 ? 0 : "1px" }}>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.OwnershipDeedNo")}>
                            <span className="link-internal" onClick={() => this.odLinkClicked(cuId, d.ownershipDocumentNumber)}>
                                {d.ownershipDocumentNumber}
                            </span>
                        </td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.RecordType")}><Translate id={`PropertySk.RecordType.${d.type}`} /></td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.Area")}>{d.area}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.ItemType")}>{d.landType}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.Location")}>{d.location}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.LandId")}>{d.landId}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.OwnershipShare")}>{d.shareNumerator}/{d.shareDenominator}</td>
                        <td data-label={this.props.translate("PropertySk.CadastreUnit.Burden")}><Translate id={d.hasDocument ? "Common.Yes" : "Common.No"} /></td>
                    </tr>)}
            </>
        );
    }

    expandClicked = (cuId) => {
        if (!this.state.expanded && isNullOrUndefined(this.props.search.propertySk.cadastreUnitData) || isNullOrUndefined(this.props.search.propertySk.cadastreUnitData[cuId])) {
            this.props.propertySkSearch({
                searchBy: propertySkSearchBy.odDetail,
                cadastreUnitId: cuId,
                hash: isNullOrUndefined(this.props.hash) || this.props.hash === "" ? undefined : this.props.hash,
                entityId: isNullOrUndefined(this.props.entityId) ? undefined : this.props.entityId
            });
        }
        this.setState({ expanded: !this.state.expanded })
    }

    odLinkClicked = (cuId, odNo) => {
        this.props.propertySkReset();
        this.props.history.push(`ownership-deed${this.createOdQueryString(cuId, odNo)}`)
    }

    createOdQueryString = (cuId, odNo) => {
        if (isNullOrUndefined(cuId) || isNullOrUndefined(odNo))
            return "";

        let query = `?cadastreUnitId=${cuId}&ownershipDeedNo=${odNo}`;
        if (!isNullOrUndefined(this.props.entityId))
            query += `&companyId=${this.props.entityId}`;
        else if (!isNullOrUndefined(this.props.hash))
            query += `&hash=${encodeURIComponent(this.props.hash)}`;

        return query;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search }, layout: state.layout }),
    dispatch => bindActionCreators(searchActions, dispatch)
)(PropertySkCadastreUnit)));